import { render } from "./SidebarChatHost.vue?vue&type=template&id=194874e0&scoped=true"
import script from "./SidebarChatHost.vue?vue&type=script&lang=js"
export * from "./SidebarChatHost.vue?vue&type=script&lang=js"

import "./SidebarChatHost.vue?vue&type=style&index=0&id=194874e0&scoped=true&lang=css"
import "./SidebarChatHost.vue?vue&type=style&index=1&id=194874e0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194874e0"]])

export default __exports__